import {useEffect,useRef} from 'react';
import {useLocation} from 'react-router-dom';

// Client-side navigation must give keyboard and screen-reader users a content entry point.
export default function RouteFocus(){
 const {pathname}=useLocation();
 const previous=useRef(pathname);
 useEffect(()=>{
  if(previous.current===pathname)return;
  previous.current=pathname;
  function focusContent(){
   const target=document.querySelector('main h1, main, h1');
   if(!target)return false;
   // A destination may intentionally focus its own form; preserve that choice.
   const active=document.activeElement;
   if(active&&active!==document.body&&target.closest('main')?.contains(active)&&active.matches('input,textarea,select,[contenteditable="true"]'))return true;
   if(!target.hasAttribute('tabindex'))target.setAttribute('tabindex','-1');
   target.focus({preventScroll:true});
   return true;
  }
  if(focusContent())return;
  const observer=new MutationObserver(()=>{if(focusContent())observer.disconnect();});
  observer.observe(document.body,{childList:true,subtree:true});
  return()=>observer.disconnect();
 },[pathname]);
 return null;
}
